import { Link } from "react-router-dom";

export default function HowItWorks() {
  const steps = [
    {
      num: "1",
      title: "Take the Destination Quiz",
      text: "Answer six quick questions about your treatment type, budget, risk tolerance and travel flexibility. Get a personalised country recommendation in under two minutes.",
    },
    {
      num: "2",
      title: "Download the Red Flags Guide",
      text: "Our free checklist tells you exactly what to ask any clinic before you book — and which warning signs to walk away from. Don't book a deposit without it.",
    },
    {
      num: "3",
      title: "Get the Complete Safe Dental Tourism Protection System",
      text: "We have 3 options to support you which include verified clinic questions, treatment timelines, what's typically excluded from quotes, aftercare planning, and much more.",
      link: { text: "Your Protection Packages", url: "/protection-packages" },
    },
    {
      num: "4",
      title: "Book With Confidence",
      text: "Armed with the right information, you can approach clinics, compare quotes, and travel knowing you've done your due diligence.",
    },
  ];

  return (
    <section className="bg-primary-50 py-16 md:py-20 lg:py-24" id="how-it-works">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600 mb-3 block">
            How It Works
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            Three Steps to Safer Dental Care Abroad
          </h2>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-10 max-w-2xl mx-auto">
            Follow our simple process to go from confusion to confident decision-making.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-10">
            {steps.map((step) => (
              <div key={step.num} className="text-left">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-foreground-950 font-bold text-lg mb-4">
                  {step.num}
                </div>
                <h4 className="text-base md:text-lg font-semibold text-foreground-950 mb-2">
                  {step.title}
                </h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {step.text}
                  {step.link && (
                    <>
                      {" "}
                      <Link
                        to={step.link.url}
                        className="text-primary-600 hover:text-primary-700 underline underline-offset-2"
                      >
                        {step.link.text}
                      </Link>
                    </>
                  )}
                </p>
              </div>
            ))}
          </div>

          <Link
            to="/quiz"
            className="inline-flex items-center justify-center px-6 py-3 text-base font-medium rounded-md bg-primary-500 text-foreground-950 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            Start the Free Quiz
            <span className="w-5 h-5 flex items-center justify-center ml-2">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}